import tw, { styled } from "twin.macro"

export const Card = styled.article`
  ${[tw`bg-white`, tw`desktop:(flex items-stretch) desktop:all-child:(w-1/2)`]}
`
